import React from 'react'
import { Grid } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { useStyles } from './Styles'
import PageTitle from '../../PageTitle/PageTitle'
import CurrencyForm from './CurrencyForm'
import { NamedRoutes } from '../../../../routes'
import BreadCrumb from '../../BreadCrumb'
import { CurrencyConsumer } from '../../../../CurrencyContext'
import { FormLoader } from '../../../Loader/FormLoader'
import Alert from '@material-ui/lab/Alert'

export default function CurrencyEditContent({ pageTitle }) {
  const classes = useStyles()

  return (
    <>
      <BreadCrumb links={[
        {
          key: 'BreadcrumbLink-1',
          name: <FormattedMessage id='Sidebar.Links.Currencies' />,
          link: NamedRoutes.workspace.currencies.list
        }
      ]} current={pageTitle ?? <FormattedMessage id='Currencies.Form.AddTitle' />} />
      <PageTitle title={pageTitle ?? <FormattedMessage id='Currencies.Form.AddTitle'/>}/>
      <CurrencyConsumer>
        {({ isEdit, isLoading, currencyData, currencyDataFailure, handleSubmit }) => (
          <Grid container spacing={4}>
            <Grid item xs={12} className={classes.EditProfileContentContainer}>
              <div className={classes.EditProfileContent}>
                {!!isLoading && <FormLoader loading={true} />}
                {!!currencyDataFailure &&
                  <Alert severity="error"><FormattedMessage id='UpdateProfile.FormErrorAlert' /></Alert>
                }
                {!isLoading && (
                  !!isEdit ?
                    (!!currencyData && !!Object.keys(currencyData).length &&
                      <CurrencyForm currencyData={currencyData} onSubmit={handleSubmit} />
                    )
                    :
                    <CurrencyForm currencyData={{}} onSubmit={handleSubmit} />
                )}
              </div>
            </Grid>
          </Grid>
        )}
      </CurrencyConsumer>

    </>
  )
}

